import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Tooltip,
  Typography
} from '@mui/material';

interface UnsavedChangesDialogProps {
  open: boolean;
  onCancel: () => void;
  onDiscard: () => void;
  onSave: () => void;
}

export const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({
  open,
  onCancel,
  onDiscard,
  onSave
}) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Unsaved Changes</DialogTitle>
      <DialogContent>
        <Typography>
          You have unsaved changes. Save before moving to next rule?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Tooltip title="Cancel current action and stay on this rule">
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        </Tooltip>
        
        <Tooltip title="Discard changes and move to another rule">
        <Button onClick={onDiscard} color="primary">
          Discard
        </Button>
        </Tooltip>
        <Tooltip title="Save current changes and move to another rule">
        <Button onClick={onSave} color="primary" variant="contained">
          Save
        </Button>
        </Tooltip>
      </DialogActions>
    </Dialog>
  );
};
